import React, { useMemo } from "react";
import { CampaignColumns } from "@/shared/utils/utils";
import CustomTable, {
  TABLE_SCROLL_HEIGHT,
} from "@/shared/components/ui/Button/CustomTable";
import NoDataFound from "@/shared/components/ui/NoDataView/NoDataFound";

const CampaignTable = ({
  displayData,
  totalCount,
  isLoading,
  searchValue,
  rowsPerPage,
  setRowsPerPage,
  renderCell,
  selectedCampaigns,
  setSelectedCampaigns,
  onSelectionChange,
  onRowClick,
  enableSelection = true,
  actions,
  page = 1,
  onPageChange,
  height = TABLE_SCROLL_HEIGHT,
}) => {
  const data = displayData ?? [];
  const search = searchValue ?? "";

  const columns = useMemo(
    () =>
      actions
        ? CampaignColumns
        : CampaignColumns.filter((col) => col.uid !== "actions"),
    [actions],
  );

  return (
    <>
      {data.length === 0 &&
        totalCount === 0 &&
        !isLoading &&
        search.length > 0 ? (
        <NoDataFound
          title="No Campaigns Found"
          description="No campaigns found for the search term"
          searchValue={search}
        />
      ) : (
        data.length > 0 &&
        !isLoading && (
          <div className="flex flex-col gap-2.5 h-full w-full">
            <div className="mt-4">
              <CustomTable
                renderCell={renderCell}
                columns={columns}
                data={data}
                rowsPerPage={rowsPerPage}
                setRowsPerPage={setRowsPerPage}
                totalCount={totalCount}
                page={page}
                enableSelection={enableSelection}
                headerColor="bg-white dark:bg-gray-900"
                selectedItems={selectedCampaigns}
                setSelectedItems={setSelectedCampaigns}
                onSelectionChange={onSelectionChange}
                height={height}
                onRowClick={onRowClick}
                onPageChange={onPageChange}
                pl="pl-2"
                pr="pr-2"
                pinFirstColumn

              />
            </div>
          </div>
        )
      )}
    </>
  );
};

export default CampaignTable;
